import { api } from "./api";

export class UserService {
  async post(value: string) {
    try {
      const response = await api.post(`/user`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async get() {
    try {
      const response = await api.get(`/user`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async getMe() {
    try {
      const response = await api.get(`/user/me`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async getById(id: string) {
    try {
      const response = await api.get(`/user/${id}`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async patch(value: string, id: string) {
    try {
      const response = await api.patch(`/user/${id}`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async delete(id: string) {
    try {
      const response = await api.delete(`/user/${id}`);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }
}
